module.exports = __webpack_public_path__ + "static/gatorbar-2ab3d3767ddaa5e90946951f75c3947e.png";